import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import store from './Store';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Auth from "./Auth/Auth";
//import Auth from './Auth/Auth';
import Callback from './Callback/Callback';
import {Provider} from "react-redux";

//const auth = new Auth();


ReactDOM.render(
    <Provider store={store}>
  
    <App/>
    </Provider>, document.getElementById('root'));
registerServiceWorker();
